module.exports = __webpack_public_path__ + "img/top3.1766306608134.png";